import { inject, Injectable } from '@angular/core';
import { PlayRecordFormService } from '../play-record-form.service';
import { FormGroup } from '@angular/forms';
import { createFormValue, PlayFileImportForm } from '@r1-compass-library/models/play/play-file-import-form.model';
import { PlayFileImport } from '@r1-compass-library/models';

export function populatePlayImporterForm(
    playImporterForm: FormGroup<PlayFileImportForm>,
    playFileImport?: PlayFileImport | undefined,
    playObjectName?: string,
    recommendationObjectName?: string
) {
    playImporterForm.setValue(
        createFormValue(playImporterForm, playFileImport, playObjectName, recommendationObjectName)
    );
    playImporterForm.markAllAsTouched();
}

@Injectable()
export class PlayImporterFormService {
    readonly #playRecordFormService = inject(PlayRecordFormService);

    public playBuilderForm: FormGroup<PlayFileImportForm> = this.#playRecordFormService.playImporterForm;

    public populatePlayImporterForm(
        playBuilderForm: FormGroup<PlayFileImportForm>,
        playFileImport?: PlayFileImport | undefined,
        playObjectName?: string,
        recommendationObjectName?: string
    ) {
        populatePlayImporterForm(playBuilderForm, playFileImport, playObjectName, recommendationObjectName);
    }
}
